<template>
  <div id="contract">
    <!-- 合同信息模块 -->
    <diy-table
      :model="'contract'"
      :tableData="data.tableData"
      :tableMenu="data.tableMenu"
      :searchData="data.searchData"
      :searchButton="data.searchButton"
      :pageData="data.pageData"
      @showTableData="showTableData"
      @showSearchData="showSearchData"
      @showPageData="showPageData"
      @handleSearch="handleSearch"
      @handleClick="handleClick"
      @handleSelectionChange="handleSelectionChange"
    ></diy-table>

    <diy-dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.data"
      :buttonList="dialogData.buttonList"
      @showDialogData="showDialogData"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
      @handleAvatarSuccess="handleAvatarSuccess"
      @handleError="handleError"
      @beforeAvatarUpload="beforeAvatarUpload"
      @downloadModel="downloadModel"
    ></diy-dialog>

    <diy-drawer
      v-if="drawerData.flag"
      :drawerData="drawerData.data"
      :title="drawerData.title"
      :buttonList="drawerData.buttonList"
      @showDrawerData="showDrawerData"
      @colseDrawer="colseDrawer"
      @handleDrawerButton="handleDrawerButton"
      @handleSuccessContractFile="handleSuccessContractFile"
      @handleErrorContractFile="handleErrorContractFile"
      @beforeUploadContractFile="beforeUploadContractFile"
    ></diy-drawer>
  </div>
</template>
<script>
import * as ContractData from "./contract.js";
import * as contract from "@/api/contract/contract.js";
import * as CommonData from "@/api/common/common.js";
import { exportData } from "@/utils/requestPOST";
import { getAuthority } from "@/api/auth/auth.js";
import { getMenuBtn } from "@/views/menu.js";
export default {
  inject: ["reload"],
  data() {
    return {
      data: this.$base.initData("contract"),
      multipleSelection: [],
      dialogData: {
        tempData: {},
        flag: false,
        title: "",
        width: "",
        data: [],
        buttonList: [],
      },

      drawerData: {
        flag: false,
        width: "20%",
        title: "",
        data: [],
        buttonList: [],
      },
      staffListData: [], //员工下拉框数据
      id: "",
    };
  },
  methods: {
    async initTableData() {
      let requestData = {
        pageSize: this.data.pageData.pageSize,
        currentPage: this.data.pageData.currentPage,
      };
      let showName = "";
      this.data.searchData.forEach((element) => {
        if (element.type == "autocomplete") {
          if (
            this.$total.searchValueByKey(
              element.options,
              element.value,
              "id",
              "name"
            ) != element.showText
          ) {
            element.value = element.showText;
            showName = element.showText;
          }
          if (element.showText == "") {
            element.showText = "";
            element.value = "";
            showName = "";
          } else {
            showName = element.showText;
          }
        }
      });

      requestData = this.$total.array2json(this.data.searchData, requestData);
      if (requestData.greenProjectTime && requestData.greenProjectTime.length == 2) {
        this.$set(requestData, "sT", requestData.greenProjectTime[0]);
        this.$set(requestData, "eT", requestData.greenProjectTime[1]);
      }
      let contractListData = await contract.listContract(requestData);
      if (contractListData.tableData.length != 0) {
        showName =
          showName == "" ? showName : showName + ": 的合同信息内容如表所示";
        if (showName != "") {
          this.$notify({
            title: "查询成功",
            type: "success",
            message: showName,
          });
        }
        sessionStorage.removeItem("detailId");
      } else {
        this.$notify.error({
          title: "无查询结果",
          message: "未查询到该员工的合同信息",
        });
        sessionStorage.removeItem("detailId");
      }
      this.data.tableData = contractListData.tableData
        ? contractListData.tableData
        : [];
      this.data.pageData.total = contractListData.total
        ? contractListData.total
        : 0;
    },
    /**
     * 顶部搜索按钮点击事件
     * @param {*} key
     */
    async handleSearch(key) {
      switch (key) {
        case "search":
          // 查询
          // this.data.pageData.currentPage = 1;
          await this.initTableData();
          break;
        case "add":
          // 新增
          this.drawerData.title = "添加合同基础信息";
          this.drawerData.buttonList = [
            { name: "确定", key: "sureAddEmploy" },
            { name: "取消", key: "cancel" },
          ];
          this.drawerData.data = ContractData.returnEditData();
          this.$total.fillArrayOptions(
            this.drawerData.data,
            "displayName",
            this.$total.changeKeyForArray(this.staffListData)
          );
          this.drawerData.flag = true;
          break;
        case "edit":
          // 编辑
          if (
            this.multipleSelection.length == 0 ||
            this.multipleSelection.length > 1
          ) {
            this.$message({
              message: "请选择一条数据进行编辑!",
              type: "error",
            });
            return;
          }
          this.drawerData.title = "编辑合同基础信息";
          this.drawerData.buttonList = [
            { name: "确定", key: "sureUpdateEmploy" },
            { name: "取消", key: "cancel" },
          ];
          this.drawerData.data = ContractData.returnEditData();

          //当合同导入的时候没有放入附件时，合同附件为空
          if (!this.multipleSelection[0].contractFile) {
            this.drawerData.data.forEach((item) => {
              if (item.key == "contractFile") {
                item.fileName = "";
              }
            });
          } else {
            //处理合同附件的名称
            let fileName = this.multipleSelection[0].contractFile
              .split("/")
              .pop();
            let newFileName = fileName.split("_")[0] + ".pdf";
            this.drawerData.data.forEach((item) => {
              if (item.key == "contractFile") {
                item.fileName = newFileName;
              }
            });
          }
          this.drawerData.data = this.$total.json2array(
            this.drawerData.data,
            this.multipleSelection[0]
          );
          this.drawerData.flag = true;
          break;
        case "delete":
          // 删除
          if (this.multipleSelection.length == 0) {
            this.$message({
              message: "请至少选择一条数据进行删除操作!",
              type: "error",
            });
            return;
          }
          this.$confirm("此操作将永久删除所选的信息, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              let ids = [];
              this.multipleSelection.forEach((item) => {
                ids.push(item.id);
              });
              let requestData = { ids: ids };
              await contract.delContract(requestData);
              await this.initTableData();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
          break;
        case "import":
          // 导入
          this.dialogData.flag = true;
          this.dialogData.width = "30%";
          this.dialogData.title = "导入合同基础信息";
          this.dialogData.buttonList = [
            { name: "上传", key: "sureImportPayroll" },
            { name: "取消", key: "cancel" },
          ];
          this.dialogData.data = ContractData.returnDialogData();
          break;
        case "export":
          // 导出
          let requestData = {};
          requestData = this.$total.array2json(
            this.data.searchData,
            requestData
          );
          let sT;
          let eT;
          if (requestData.greenProjectTime.length == 0) {
            sT = "";
            eT = "";
          }
          if (requestData.greenProjectTime.length > 0) {
            sT = requestData.greenProjectTime[0];
            eT = requestData.greenProjectTime[1];
          }

          let exportURL =
            process.env.VUE_APP_BASE_API +
            `/business/contract/exportContract?userId=${requestData.userId}&contractStatus=${requestData.contractStatus}&sT=${sT}&eT=${eT}`;
          window.open(exportURL, "_blank");
          break;

        default:
          break;
      }
    },
    /**
     * 表格按钮点击事件
     * @param {*} val
     */
    handleClick(val) {
      let row = val.row;
      let key = val.key;
      switch (key) {
        case "contractFile":
          // 合同附件
          if (row.contractFile == "" || row.contractFile == null) {
            this.$message({
              message: "请先上传合同附件!",
              type: "error",
            });
            return;
          } else {
            window.open(row.contractFile, "_blank");
          }

          break;

        default:
          break;
      }
    },

    /**
     * 弹出框的操作事件
     * @param {*} key
     */
    async dialogOper(key) {
      let requestData = {};
      let flag;
      switch (key) {
        //导入合同基础信息
        case "sureImportPayroll":
          let templateData = {};
          templateData = this.$total.array2json(
            this.dialogData.data,
            templateData
          );
          requestData.filePath = templateData.filePath;

          let res = await contract.importContract(requestData);
          if (res.flag) {
            this.$message({
              message: "新闻资讯导入成功!",
              type: "success",
            });
            this.dialogData.flag = false;
            await this.initTableData();
          } else {
            this.$message({
              message: res.errInfo ? res.errInfo : "导入失败",
              type: "error",
            });
          }
          break;
        case "cancel":
          this.colseDialog();

          break;

        default:
          break;
      }
    },
    /**
     * 抽屉按钮点击事件
     * @param {*} key
     */
    async handleDrawerButton(key) {
      let requestData = {};
      let flag;
      let F;
      switch (key) {
        case "cancel":
          this.colseDrawer();
          break;
        case "sureAddEmploy":
          // 添加合同基础信息
          flag = this.$total.judegArrayNull(this.drawerData.data);
          if (flag != "ok") {
            this.$message.error(flag + "不能为空");
            return;
          }
          F = this.$total.judegTime(
            this.drawerData.data,
            "contractStartDate",
            "contractEndDate"
          );
          if (!F) {
            this.$message.error("合同开始日期不能大于合同结束日期");
            return;
          }
          requestData = this.$total.array2json(
            this.drawerData.data,
            requestData
          );
          requestData.userId = requestData.displayName;
          await contract.addContract(requestData);
          this.$message({
            message: "合同基础信息添加成功!",
            type: "success",
          });
          this.drawerData.flag = false;
          await this.initTableData();

          break;
        case "sureUpdateEmploy":
          // 编辑合同基础信息
          flag = this.$total.judegArrayNull(this.drawerData.data);
          if (flag != "ok") {
            this.$message.error(flag + "不能为空");
            return;
          }
          F = this.$total.judegTime(
            this.drawerData.data,
            "contractStartDate",
            "contractEndDate"
          );
          if (!F) {
            this.$message.error("合同开始日期不能大于合同结束日期");
            return;
          }
          requestData = this.$total.array2json(
            this.drawerData.data,
            requestData
          );

          requestData.userId = this.multipleSelection[0].userId;
          requestData.id = this.multipleSelection[0].id;
          await contract.editContract(requestData);
          this.$message({
            message: "合同基础信息修改成功!",
            type: "success",
          });
          this.drawerData.flag = false;
          await this.initTableData();
          break;

        default:
          break;
      }
    },
    //导入合同信息
    handleAvatarSuccess(response, file, fileList) {
      switch (response.result.title) {
        case "合同信息":
          // 合同信息
          this.dialogData.data.forEach((element) => {
            if (element.key == "filePath") {
              element.value = response.result.url;
              element.fileList = [fileList[fileList.length - 1]];
            }
          });
          break;

        default:
          break;
      }
    },
    handleError() {
      this.$message({
        message: "文件上传失败!",
        type: "warning",
      });
    },
    beforeAvatarUpload(file, callback) {
      const isXlS =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isXlS) {
        this.$message({
          message: "仅支持上传xlsx格式和xls格式!",
          type: "warning",
        });
      }
      callback(isXlS);
    },
    //新增合同信息的导入合同附件
    async handleSuccessContractFile(response, file, fileList) {
      switch (response.result.title) {
        case "合同附件":
          // 合同附件
          this.drawerData.data.forEach((element) => {
            if (element.key == "contractFile") {
              element.value = response.result.url;
              element.fileName = response.result.name;
            }
          });
          break;

        default:
          break;
      }
    },
    handleErrorContractFile() {
      this.$message({
        message: "文件上传失败!",
        type: "warning",
      });
    },
    beforeUploadContractFile(file, callback) {
      const isXlS = file.type === "application/pdf";
      if (!isXlS) {
        this.$message({
          message: "仅支持上传pdf格式!",
          type: "warning",
        });
      }
      callback(isXlS);
    },
    //模版下载
    async downloadModel() {
      let requestData = {
        flag: "5",
      };
      await exportData(requestData, "/downloadMode", "合同信息");
    },
    /**
     * 添加或修改新闻资讯
     * @param {*} flag
     */
    async saveOrUpdateEmploy(flag) {},

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    showTableData(val) {
      this.data.tableData = val;
    },
    showSearchData(val) {
      this.data.searchData = val;
    },
    showPageData(val) {
      this.data.pageData = val;
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
    showDialogData(val) {
      this.dialogData.data = val;
    },
    colseDrawer() {
      this.drawerData.flag = false;
    },
    showDrawerData(val) {
      this.drawerData.data = val;
    },
  },
  async mounted() {
    //获取按钮权限
    let button = await getAuthority({ type: "F", modelId: "5" });
    if (button.length == 0) {
      this.data.searchButton = [];
    }
    if (button.length > 0) {
      this.data.searchButton = getMenuBtn(button, this.data.searchButton);
    }
    //获取员工下拉框
    this.staffListData = await CommonData.employListForSelect();
    this.$total.fillArrayOptions(
      this.data.searchData,
      "userId",
      this.staffListData
    );
    let detailId = sessionStorage.getItem("detailId")
      ? sessionStorage.getItem("detailId")
      : "";
    //判断是从新闻资讯界面跳转过来的
    if (detailId != "") {
      let n = this.$total.searchValueByKey(
        this.staffListData,
        detailId,
        "id",
        "name"
      );
      this.data.searchData.forEach((element) => {
        if (element.key == "userId") {
          element.value = detailId;
          element.showText = n;
        }
      });
      sessionStorage.removeItem("detailId");
    } else {
      this.data.searchData.forEach((element) => {
        if (element.key == "userId") {
          element.value = "";
          element.showText = "";
        }
      });

      sessionStorage.removeItem("detailId");
    }
    await this.initTableData();
  },
};
</script>
<style lang="less" scoped>
#contract {
  width: 100%;
  height: 100%;
  display: flex;
}
</style>
